// Special-visit display name, shared across API, agency, PDF, and reporting.
//
// All special visits point at the single `kind='special'` visit_types row, so the
// visit-type join always yields the generic "Special Visit". The real per-visit name
// lives on `special_form_instances.visit_name` (LLM-suggested, agency-editable), with
// `curated_type_value` as the routed primary type. This helper centralizes the one
// fallback chain so every surface labels a special visit identically.
//
// The keys MUST match `special-library.service.ts` TYPE_VALUE (the curated library
// type values) — a test asserts they stay in sync against the live library rows.
export const CURATED_TYPE_LABELS = {
    wellness: "Wellness Check",
    fall: "Fall Follow-Up",
    wound: "Wound-Skin Follow-Up",
    posthosp: "Post-Hospitalization",
    resumption: "Resumption of Care"
};
/** The generic fallback when nothing more specific is available. */
export const GENERIC_SPECIAL_VISIT_LABEL = "Special Visit";
/**
 * Resolve the display name for a special visit.
 *
 * Fallback chain (empty/whitespace strings count as absent, so a cleared name never
 * renders blank):
 *   1. `visitName` (trimmed, non-empty)         — the agency-edited / LLM-suggested name
 *   2. label for `curatedTypeValue`             — the routed curated type
 *   3. "Special Visit"                          — generic
 */
export function specialVisitLabel(input) {
    const name = input.visitName?.trim();
    if (name) {
        return name;
    }
    const key = input.curatedTypeValue?.trim();
    // own-property check (not `in`) so prototype keys like "constructor"/"toString" don't match.
    if (key && Object.prototype.hasOwnProperty.call(CURATED_TYPE_LABELS, key)) {
        return CURATED_TYPE_LABELS[key];
    }
    return GENERIC_SPECIAL_VISIT_LABEL;
}
//# sourceMappingURL=special-visit-label.js.map